export default class incidenciaService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/incidencias',
			"id": '/api/incidencias/:id',
			"new": '/api/incidencias',
			'delete': '/api/incidencias/:id',
			"anular": '/api/incidencias/anular',
			"pdf": "/api/incidencias/pdf",
			"getPdf": "/api/incidencias/pdf/:pdf"
		};
	}

	getAll(params){
		let url = this.baseUrl + this.routes.all;
		var config = {};
		if (params !== undefined) {
			if (typeof params == 'string') {
				config.params = {};
				config.params.string = params;
			}else{
				config.params = {};
				for (var element in params) {
					config.params[element] = params[element];
				}
				config.params.proyectos = params.proyectos;
			}
		}

		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	update(data){
		let url = this.baseUrl + this.routes.all;
		return this.http.put(url, data);
	}

	anular(data){
		let url = this.baseUrl + this.routes.anular;
		return this.http.post(url, data);
	}

	destruct(objId){
		let url = this.baseUrl + this.routes.delete;
		let idRoute = this.routes.delete.replace(':id', objId);
		this.http.delete();
	}

	pdf(data){
		let url = this.baseUrl + this.routes.pdf;
		return this.http.post(url, data);
	}

	getPdf(data){
		let idRoute = this.routes.getPdf.replace(':pdf', data.pdf);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/incidenciaService.js